import * as React from 'react';
import { Body1 } from '@cian/ui-kit';

import * as styles from './NewbuildingHeaderCompareButton.css';

export function CompareOnboardingContent() {
  return (
    <div className={styles['onboarding-content']} data-testid="NewbuildingCompareOnboarding">
      <Body1 color="text-inverted-default">
        Сравните этот ЖК с другими: таблица и&nbsp;выводы будут в&nbsp;избранном
      </Body1>
    </div>
  );
}
